import styled from 'styled-components'
import { Box } from '~/components/Box'

export const StyledBalanceWarning = styled.div`
  padding: 10px 0px 10px 15px;
  background: rgba(208, 83, 83, 0.1);
  border: 1px solid rgba(208, 83, 83, 0.2);
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textDanger};
`

export const StyledReviewBox = styled(Box)<{ $pad?: boolean }>`
  ${({ $pad }) => $pad && `padding: 0 15px;`}
`
